import React, { useEffect } from "react";
import { useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

interface Props {
    open: boolean;
}

export default function OfflineTipDialog({ open }: Props) {
    const [dialogOpen, setDialogOpen] = React.useState(open);
    const theme = useTheme();
    const handleClose = () => {
        setDialogOpen(false);
    }

    useEffect(() => {
        setDialogOpen(open);
    }, [open]);

    return (
        <React.Fragment>
            <Dialog
                open={dialogOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        bgcolor: theme.palette.online_status.offline,
                        p: 3,
                        maxWidth: 400,
                    }
                }}
            >
                <DialogContent
                    sx={{
                        color: "white",
                        bgcolor: "transparent",
                        p: 0,
                        mb: 2,
                        textAlign: "center",
                    }}
                >
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            color: "white",
                            lineHeight: 1.6,
                        }}
                    >
                        您現時處於離線狀態，所有紀錄將會在本地存儲。恢復在線後將會自動同步。
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        p: 0,
                        justifyContent: "center",
                    }}
                >
                    <Button 
                        onClick={handleClose}
                        fullWidth
                        sx={{
                            bgcolor: "white",
                            color: theme.palette.online_status.offline,
                            borderRadius: 3,
                            fontSize: 16,
                            py: 0.5,
                            fontWeight: 400,
                            "&:hover": {
                                bgcolor: "rgba(255, 255, 255, 0.9)",
                            }
                        }}
                    >
                        確認
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

